export class InMemoryCache {
  private store: { [key: string]: Promise<any> } = {};

  public get<T>(key: string, defaultCaller: () => Promise<T>): Promise<T> {
    if (!this.store[key]) {
      this.store[key] = defaultCaller();
    }
    return this.store[key] as Promise<T>;
  }
}
